import {ESLMixinElement} from '@exadel/esl/modules/esl-mixin-element/core';
import {attr, listen} from '@exadel/esl/modules/esl-utils/decorators';
import {HPEAssetViewerModalShared} from './asset-viewer-modal-shared';

export class HPEAssetViewerLinkMixin extends ESLMixinElement {
  public static is = 'hpe-asset-viewer-link';

  @attr({name: HPEAssetViewerLinkMixin.is}) public assetId: string;
  @attr({name: 'hpe-asset-viewer-subpath'}) public assetSubpath: string;

  @listen('click')
  protected _onClick(e: MouseEvent): void {
    e.preventDefault();
    e.stopImmediatePropagation();
    HPEAssetViewerModalShared.show({
      activator: this.$host,
      assetId: this.assetId,
      assetSubpath: this.assetSubpath
    });
  }
}
